// Per-tab browsing session id.
//
// Deliberately the same sessionStorage key the Amplitude event stream uses, so
// engagement events and product analytics can be joined on session_id later
// without a correlation table. sessionStorage (not localStorage) is what makes
// it a *session*: it dies with the tab, which is the unit a feed ranker cares
// about — one sitting of scrolling.
const SESSION_STORAGE_KEY = 'amplitude_session_id'

export function analyticsSessionId(): string | null {
    try {
        if (typeof window === 'undefined' || !window.sessionStorage) return null

        const existing = window.sessionStorage.getItem(SESSION_STORAGE_KEY)
        if (existing) return existing

        const sessionId = Date.now().toString()
        window.sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId)
        return sessionId
    } catch {
        // Blocked-storage contexts (Safari private mode, embedded webviews)
        // throw on access. Events stay useful without a session id.
        return null
    }
}
